import {
  AdvancedSearchConfig,
  AdvancedSearchFormField,
  SearchOperator,
} from "@/config/forms/advanced-search/advanced-search-fields-def";
import { useForm } from "react-hook-form";
import { Button } from "../ui/button";
import { Form } from "../ui/form";
import { Separator } from "../ui/separator";
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
import {
  AdvancedSearchForm,
  AdvancedSearchFormData,
} from "./AdvancedSearchForm";
import { useAdvancedSearch } from "@/context/advanced-search/AdvancedSearchContext";
import { SaveAdvancedSearchModal } from "./SaveAdvancedSearchModal";
import { useState } from "react";
import { SavedAdvancedSearchQueriesList } from "./SavedAdvancedSearchQueriesList";
import { useTranslation } from "react-i18next";

export const AdvancedSearch = ({
  config,
  resource,
}: {
  config: AdvancedSearchConfig;
  resource: string;
}) => {
  const [queryToSave, setQueryTosave] = useState<AdvancedSearchFormData>({
    fields: [],
    searchMode: "and",
  });

  const [openSaveDialog, setOpenSaveDialog] = useState<boolean>(false);

  const { t } = useTranslation();

  const form = useForm<AdvancedSearchFormData>({
    defaultValues: {
      fields: [{ type: "unknown" }],
      searchMode: "and",
    },
  });

  const advancedSearch = useAdvancedSearch();

  function onSaveAdvancedSearch(data: AdvancedSearchFormData) {
    setQueryTosave(data);
    setOpenSaveDialog(true);
  }

  function onSubmit(data: {
    fields: AdvancedSearchFormField[];
    searchMode: SearchOperator;
  }) {
    advancedSearch.setAdvancedSearchQuery({
      fields: data.fields,
      searchMode: data.searchMode,
    });
  }

  const submit = form.handleSubmit(onSubmit);

  return (
    <Sheet>
      <SheetTrigger asChild>
        <Button variant={"default"} type="button">
          {t("dashBoardAdvancedSearch")}
        </Button>
      </SheetTrigger>

      <SheetContent className="sm:max-w-5xl w-full px-0">
        <Form {...form}>
          <form onSubmit={submit} className="flex flex-col h-full">
            <SheetHeader className="p-8 py-4 border-b">
              <SheetTitle>{t("advancedSearchPageTitle")}</SheetTitle>
            </SheetHeader>
            <div className="flex flex-col h-full p-8 gap-8 overflow-y-auto">
              <AdvancedSearchForm
                config={config}
                onSaveAdvancedSearch={onSaveAdvancedSearch}
              />
              <Separator />
              <SavedAdvancedSearchQueriesList resource={resource} />
            </div>
            <SheetFooter className="w-full h-fit px-8 relative bottom-0">
              <SheetClose asChild>
                <Button type="button" variant={"secondary"} className="w-full">
                  {t("advancedSearchClose")}
                </Button>
              </SheetClose>
              <Button
                disabled={!form.formState.isValid}
                type="submit"
                variant={"default"}
                className="w-full"
              >
                {t("advancedSearchLaunch")}
              </Button>
            </SheetFooter>
          </form>
        </Form>
        <SaveAdvancedSearchModal
          resource={resource}
          query={queryToSave}
          open={openSaveDialog}
          onOpenChange={setOpenSaveDialog}
        />
      </SheetContent>
    </Sheet>
  );
};
